export default __webpack_public_path__ + "locales/uk-UA/PDFFormDialog.json?hash=c2eaba85c4038e7568b5f775036cef55";